
import { isDark } from '../../state/darkModeState'
import { useStorage, usePreferredDark, useToggle } from '@vueuse/core'
const colorSchema = useStorage('color-schema', 'auto')
const preferredDark = usePreferredDark()
type StepId = 'login' | 'reset-password'
import ResetForm from './ResetForm.vue'

export default {
  name: 'Reset',
  components:{
    ResetForm
  },
  setup(){
    return {
      isDark
    }
  }
}
